/** Curated pub one-liners for the brand-mug easter egg. */
const PUB_TOASTS = [
  'За буквы — и за тех, кто их всё-таки собрал!',
  'В этом пабе анаграммы щедрее чаевых.',
  'Слово дня уже на стойке — только переставь буквы.',
  'Кто угадал быстро, тот и пену не сдул.',
  'Бармен шепчет: не пей буквы по одной.',
  'Сегодня слово прячется лучше чаевых в кармане.',
  'За тех, кто видит слово раньше соседей!',
  'Анаграмма — как кружка: сперва встряхни, потом пей.',
  'Если буквы пляшут — ты уже почти у цели.',
  'Паб не судит: ошибайся громко, угадывай гордо.',
  'Слово дня не убежит — максимум пересядет за другой стол.',
  'Тост: за перестановки, что ведут к победе!',
  'Буквы у нас честные — просто в случайном порядке.',
  'Кто медлит, тот изучает меню подольше.',
  'Знаменитости паба рождаются из удачных догадок.',
  'Сегодня без подсказок — только интуиция и кружка.',
  'Слово само просится на язык, но буквы вредничают.',
  'Загадка дня легче вчерашней — или так кажется.',
  'Бармен ставит на тех, кто не сдаётся на третьей букве.',
  'Переставь буквы — и мир станет чуть яснее.',
  'В пабе «Слово Дня» тишина бывает только между догадками.',
  'Угадал с первой попытки? Кружка сама себя наливает… почти.',
  'Буквы любят внимание — не оставляй их в одиночестве.',
  'Тост за тех, кто читает анаграмму справа налево и всё равно угадывает!',
  'Скорость хороша, но буква на месте — ещё лучше.',
  'Сегодняшнее слово уже кивает из угла.',
  'Пабный закон: одна кружка — одна смелая гипотеза.',
  'Не ругай буквы: они просто перепутали очередь.',
  'За смех за стойкой и слова, что наконец сложились!',
  'Анаграмма улыбается тем, кто не спешит сдаваться.',
  'Игрок дня — тот, кто увидел смысл в хаосе букв.',
  'Бармен знает слово, но молчит из профессиональной этики.',
  'Если буквы шепчут — прислушайся, не глуши их пеной.',
  'Слово дня сегодня в хорошем настроении.',
  'За тех, кто угадывает тихо, но точно!',
  'Перестановка букв — наш фирменный рецепт.',
  'Кто ищет слово, тот уже нашёл компанию.',
  'В пабе каждая ошибка звучит как тост за опыт.',
  'Буквы рассыпались — собери их до последней капли смысла.',
  'Знаменитость паба начинается с одной верной догадки.',
  'Сегодня играем мягко: слово само подмигивает.',
  'Тост: за алфавит, который снова нас развлёк!',
  'Не гони буквы — пусть сами встанут в ряд.',
  'Угадывать слова здесь вкуснее, чем читать меню.',
  'Паб верит: даже путаница букв достойна оваций.',
  'Слово дня ждёт тех, кто не боится перестановок.',
  'Быстро угадал — медленно радуйся, это тоже традиция.',
  'За соседей по столу, что подсказывают глазами!',
  'Анаграмма — честная шутка: всё на виду, ничего не ясно.',
  'Буква к букве — и вот уже паб рукоплещет.',
  'Сегодня без драмы: только слова и хорошая пена.',
  'Кто перепутал буквы местами — тот мыслит по-пабному.',
  'Слово прячется в анаграмме, как ключ в кармане фартука.',
  'Тост за терпение и за внезапное «эврика!»',
  'Бармен подмигивает: ты ближе, чем кажется.',
  'В «Слове Дня» побеждает не громкость, а догадка.',
  'Буквы сегодня дружелюбные — почти сами складываются.',
  'Угадал поздно? В пабе поздних не бывает — только легендарных.',
  'За те слова, что приходят вместе со вторым глотком!',
  'Анаграмма любит смелых и чуть-чуть упрямых.',
  'Слово дня уже налито — осталось его произнести.',
  'Игрок шепчет буквы, паб делает вид, что не слышит.',
  'Переставь три буквы — и тост станет осмысленнее.',
  'Здесь хвалят и за скорость, и за красивую ошибку.',
  'Пабные знаменитости помнят свои первые угаданные слова.',
  'Буквы в беспорядке — порядок в голове ещё впереди.',
  'Тост: за ежедневное слово и тех, кто за ним пришёл!',
  'Сегодняшняя анаграмма мягче вчерашней кружки.',
  'Не сдавайся на половине алфавита.',
  'Слово само выйдет, если дать буквам шанс.',
  'Бармен шутит: лучшая подсказка — это твоя улыбка сомнения.',
  'Загадка дня просит не спешить и не скучать.',
  'Угадывать вместе веселее, чем в одиночку бормотать буквы.',
  'В пабе каждое слово когда-то было анаграммой.',
  'Тост за тех, кто видит «слово» там, где другие видят «шум»!',
  'Буквы танцуют — ты дирижёр вечера.',
  'Слово дня любит, когда его зовут по имени.',
  'Кто угадал — тот сегодня почётный гость стойки.',
  'Анаграмма не злится: она просто ждёт озарения.',
  'Пабный совет: сначала расставь буквы, потом расставляй приоритеты.',
  'Сегодня игра короткая, а радость — на весь вечер.',
  'За медленных мыслителей и быстрых буквоедов!',
  'Слово спряталось честно — все буквы на столе.',
  'Бармен ставит кружку за удачную перестановку.',
  'Если застрял — встряхни анаграмму, как пену.',
  'Знаменитости паба растут из маленьких «а что если…»',
  'Тост за новый день и новое слово в старых буквах!',
  'Угадывай смело: паб прощает почти всё, кроме скуки.',
  'Буквы сегодня в ударе — и ты можешь тоже.',
  'Слово дня не требует регалий, только внимания.',
  'В этом заведении алфавит всегда в меню.',
  'Перестановка — наш любимый жанр короткого юмора.',
  'За тех, кто шепчет ответ раньше, чем сам в него верит!',
  'Анаграмма уходит спокойно, когда её разгадали.',
  'Паб аплодирует даже почти правильным версиям.',
  'Слово уже рядом — ближе, чем свободный стул у стойки.',
  'Бармен знает: лучшие игроки умеют ждать свою букву.',
  'Сегодня без спешки: слово само найдёт дорогу к языку.',
  'Тост за «Слово Дня» — и за всех, кто снова пришёл угадывать!',
  'В пабе буквы дружат, а игроки — тем более.'
];

export function pickPubToast() {
  return PUB_TOASTS[Math.floor(Math.random() * PUB_TOASTS.length)];
}

export default PUB_TOASTS;
